import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FaSun, FaMoon } from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';
import logo from '../../assets/logo.png';

const Header = () => {
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const isAdminLoggedIn = localStorage.getItem('isAdminLoggedIn') === 'true';

  // Monitor scroll offset to adjust navbar glassmorphism intensity
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto-close mobile menu on route change
  useEffect(() => {
    setIsExpanded(false);
  }, [location.pathname]);

  return (
    <header className={`apple-navbar-wrapper ${isScrolled ? 'nav-scrolled' : ''}`}>
      <Navbar
        expand="lg"
        expanded={isExpanded}
        onToggle={(expanded) => setIsExpanded(expanded)}
        className="apple-nav"
      >
        <Container>
          {/* Apple-style Brand Logo */}
          <Navbar.Brand as={Link} to="/" className="apple-nav-brand" title="PeaceMobiles Homepage">
            <img
              src={logo}
              width="30"
              height="30"
              className="d-inline-block align-top brand-logo-img"
              alt="PeaceMobiles logo"
            />
            <span className="brand-text">PeaceMobiles</span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="apple-navbar-nav" className="apple-nav-toggle">
            <span className="toggle-bar"></span>
            <span className="toggle-bar"></span>
          </Navbar.Toggle>

          <Navbar.Collapse id="apple-navbar-nav" className="apple-nav-collapse">
            <Nav className="mx-auto apple-nav-links">
              <Nav.Link
                as={Link}
                to="/"
                className={`apple-nav-link ${location.pathname === '/' ? 'active' : ''}`}
              >
                Overview
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/products"
                className={`apple-nav-link ${location.pathname === '/products' ? 'active' : ''}`}
              >
                Products
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/about"
                className={`apple-nav-link ${location.pathname === '/about' ? 'active' : ''}`}
              >
                About Us
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/support"
                className={`apple-nav-link ${location.pathname === '/support' ? 'active' : ''}`}
              >
                Support
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/service-centre"
                className={`apple-nav-link ${location.pathname === '/service-centre' ? 'active' : ''}`}
              >
                Service Centres
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/contact"
                className={`apple-nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
              >
                Contact
              </Nav.Link>
            </Nav>

            {/* Quick Action Pill & Theme Toggle */}
            <div className="apple-nav-actions">
              {/* Dark/Light Theme Toggle Button */}
              <button
                type="button"
                onClick={toggleTheme}
                className="theme-toggle-btn"
                aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
                title={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
              >
                {theme === 'dark' ? (
                  <FaSun className="theme-toggle-icon sun-icon" />
                ) : (
                  <FaMoon className="theme-toggle-icon moon-icon" />
                )}
              </button>

              <Link to="/products" className="nav-buy-pill">
                Buy i17 Air
              </Link>

              {isAdminLoggedIn ? (
                <Link to="/admin/dashboard" className="nav-admin-link">
                  Dashboard
                </Link>
              ) : (
                <Link to="/admin/login" className="nav-admin-link">
                  Sign In
                </Link>
              )}
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
